import React, { useEffect } from "react";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import { useState, useMemo } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";

import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useLazyGetallclinicsQuery } from "../State/Api/AddClinicInfoApiSlice";

function AllClinics() {
  const navigate = useNavigate();
  const [fetchallclinic, { data: allclinicsData, isFetching, failed }] =
    useLazyGetallclinicsQuery();

  useEffect(() => {
    fetchallclinic();
  }, []);
  useEffect(() => {
    if (allclinicsData) {
      setRowData(allclinicsData);
    }
  }, [allclinicsData]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const tableStyle = `
          .ag-full-width-container{
  height : 100% !important;
}


// @media only screen and (min-width:1880px) {
//     .ag-body-horizontal-scroll{
//         display: none;
//     }
// }

.ag-icon{
 color: #fff;
 display: block;
}


.ag-header-cell-text {
font-size: 13px;
text-transform: uppercase;
color: #fff;
font-weight: 700;
font-family: var(--ct-font-Public-Sans);
}

    .ag-header-cell-resize::after{
            background-color: #1991eb52;
        }


  .ag-theme-quartz{
  padding: 0.4rem;
  }

    .ag-ltr .ag-cell{
            text-align: center;
            display: flex;
            // justify-content: center;
            align-items: center;
    }

    .ag-header{
        // background-color: #edeff6;
         border: none;
        padding: 0.5rem 0;

        min-height: 40px !important;
    }

    .ag-row {
     border: 1px solid #eeedf0;
    }

        .ag-row-odd {
background-color: #f7f7f7 !important; /* Light gray */
}


    .ag-cell{
border-left: 1px solid #eeedf0 !important;
}



    .ag-root-wrapper{
      border: unset;
      background: transparent
    }

    .ag-body-viewport{
      border: 1px solid #8080801a;
      border-top-left-radius: 5px !important;
      border-top-right-radius: 5px !important;
      background-color: white;
    }

    .ag-theme-quartz .ag-header-cell-filter-button{
    display: none;}

.ag-ltr .ag-header-cell-resize{
    }

     .ag-cell, .ag-cell-not-inline-editing, .ag-cell-normal-height, .ag-cell-value, .ag-cell-focus{
        font-size: .9rem;
     }

.ag-body-vertical-scroll{
  display : none;
}

.ag-header-cell-sortable .ag-header-cell-label{
 justify-content: start;
}

.ag-ltr .ag-cell {
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  color: #3584cdcc !important;
}


.odd-row {
background-color: #f8f8fc;
}

.span-saceuu7u7{
  font-size: 13px; 
  background-color: #FAAB3C; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-jkmkmkmkm{
  font-size: 10px; 
  color: #6941C6 ;
  border: solid .1px #6941C6; 
  background-color: #F9F5FF; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  width: 7rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.span-jkmkmkmkmjbui{
  font-size: 10px; 
  color: #175CD3 ;
  border: solid .1px #B2DDFF; 
  background-color: #EFF8FF; 
  padding: .8rem .5rem;
  border-radius: 10rem;
  width: 7rem;
  height:1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ag-header-cell-label{
display: flex;
justify-content: center;
}

 .ag-body-horizontal-scroll{
                height: 5px !important;
            max-height: 5px !important;
            min-height: 5px !important;
             }
        
             .ag-body-horizontal-scroll-viewport{
                height: 5px !important;
            max-height: 5px !important;
            min-height: 5px !important;
             }

 .ag-root ::-webkit-scrollbar-track
        {
            -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            background-color: #F5F5F5;
        }
        
        .ag-root ::-webkit-scrollbar
        {
            width: 5px;
            background-color: #F5F5F5;
        }
        
        .ag-root ::-webkit-scrollbar-thumb
        {
            background-color: #80808070;
        }
        
        .ag-root ::-webkit-scrollbar-button {
            width: 0px;
            height: 0px;
            visibility: hidden;
        } 

        `;

  const [paginationPageSize, setPaginationPageSize] = useState(20);

  const autoSizeStrategy = {
    type: "fitGridWidth",
    columnLimits: [
      {
        colId: "No of Team Members",
        minWidth: 900,
      },
    ],
  };

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      filter: true,
    };
  }, []);

  const [rowData, setRowData] = useState(allclinicsData || []);

  const [colDefs, setColDef] = useState([
    {
      field: "logoUpload",
      headerName: "Logo",
      flex: 0.7,
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        return (
          <>
            <span>
              <img
                style={{
                  width: "2.2rem",
                  height: "2.2rem",
                  borderRadius: "4rem",
                }}
                src={params.value || ""}
                alt=""
              />
            </span>
          </>
        );
      },
    },

    {
      headerName: "Clinic Name",
      field: "clinic_Hospital_Name",
      flex: 1.2,
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        return (
          <>
            <div className="d-flex align-items-center gap-2">
              <span
                className="m-0"
                style={{ fontSize: "13px", color: "#646262", fontWeight: 600 }}
              >
                {params.value || ""}
              </span>
            </div>
          </>
        );
      },
    },

    {
      field: "modules",
      headerName: "Modules",
      flex: 1.6,
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        return (
          <div className="d-flex align-items-center gap-2">
            <span
              className="tableffmy fw-normal m-0 span-jkmkmkmkm"
              style={{ fontSize: "8px" }}
            >
              {params.value?.name1 || ""}
            </span>
            <span
              className="tableffmy fw-normal m-0 span-jkmkmkmkmjbui"
              style={{ fontSize: "8px" }}
            >
              {params.value?.name2 || ""}
            </span>
          </div>
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1.5,
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        return (
          <>
            <span
              className="m-0"
              style={{ fontSize: "13px", color: "#646262", fontWeight: 600 }}
            >
              {params.value || ""}
            </span>
          </>
        );
      },
    },

    {
      field: "subscriptionStartDate",
      headerName: "Start Date",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        const formattedDate = dayjs(params.value)
          .format("DD-MMM-YYYY")
          .replace(
            /-(\w{3})-/,
            (_, month) =>
              `-${month.charAt(0).toUpperCase()}${month
                .slice(1)
                .toLowerCase()}-`
          );
        return (
          <span
            className="tableffmy fw-normal m-0"
            style={{ fontSize: "13px", color: "#05080B" }}
          >
            {formattedDate || ""}
          </span>
        );
      },
    },

    {
      field: "subscriptionEndDate",
      headerName: "End Date",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        const formattedDate = dayjs(params.value)
          .format("DD-MMM-YYYY")
          .replace(
            /-(\w{3})-/,
            (_, month) =>
              `-${month.charAt(0).toUpperCase()}${month
                .slice(1)
                .toLowerCase()}-`
          );
        return (
          <span
            className="tableffmy fw-normal m-0"
            style={{ fontSize: "13px", color: "#05080B" }}
          >
            {formattedDate || ""}
          </span>
        );
      },
    },

    {
  field: "isactive",
  headerName: "Status",
  suppressSizeToFit: true,
  cellRenderer: function (params) {
    // Map your raw values to display values
    const statusMap = {
      1: "Active",
      2: "Trial",
      3: "Expired",
      4: "Suspended",
      active: "Active",
      trial: "Trial",
      expired: "Expired",
      suspended: "Suspended",
    };

    const displayValue = statusMap[params.value] || "Unknown";

    return (
      <>
        <span
          className="tableffmy fw-normal m-0 span-saceuu7u7"
          style={{ fontSize: "13px", color: "#fff" }}
        >
          {displayValue}
        </span>
      </>
    );
  },
},

    {
      field: "userUniqueID",
      headerName: "Action",
      suppressSizeToFit: true,
      cellRenderer: function (params) {
        return (
          <>
            <div className="d-flex align-items-center justify-content-center gap-2">
              <button
                style={{ border: "none", background: "none", color: "#035ECF" }}
                onClick={handleShow}
              >
                <i class="fa-regular fa-eye"></i>
              </button>
              <button
                style={{ border: "none", background: "none", color: "#035ECF" }}
                onClick={() =>
                  navigate("/Registration", { state: { id: params?.value } })
                }
              >
                <i
                  class="fa-regular fa-pen-to-square"
                  style={{ color: "#45B369" }}
                ></i>
              </button>
              <button
                style={{ border: "none", background: "none", color: "#035ECF" }}
                onClick={handleShow}
              >
                <i
                  class="fa-regular fa-trash-can"
                  style={{ color: "#F48458" }}
                ></i>
              </button>
            </div>
          </>
        );
      },
    },
  ]);

  return (
    <>
      <div className="" style={{ backgroundColor: "#fff" }}>
        <div
          className="ag-theme-quartz" // applying the Data Grid theme
          style={{
            height: "454",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            padding: ".5rem",
          }} // the Data Grid will fill the size of the parent container
        >
          <style>{tableStyle}</style>
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            pagination={false}
            paginationPageSize={paginationPageSize}
            domLayout="autoHeight"
            rowClass={"tbl-row-sc"}
            rowHeight={40}
            headerHeight={25}
            autoSizeStrategy={autoSizeStrategy}
          />

          <Offcanvas
            show={show}
            onHide={handleClose}
            placement={"end"}
            style={{
              width: "30rem",
              margin: ".5rem .5rem",
              borderRadius: "0.5rem 0rem 0px .5rem",
            }}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title
                className="text-black"
                style={{ fontSize: "18px" }}
              >
                Filters
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div className="d-flex flex-column gap-2"></div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </>
  );
}

export default AllClinics;
